import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
import { info, error, success, warning } from "../../../../theme/colors";
export var CRMCalendarKeys = {
    appointments: 'calendarAppointments',
    slots: 'calendarSlotDetails',
    eventDetails: 'calendarEventDetails'
};
export var START_DATE = dayjs().startOf('month').add(10, 'hours');
export var SlotsAvlMap = {};
export var CalendarEventsList = new Array(120).fill({
    CustomerName: 'Rajesh Bhoir',
    RegNo: 'MH48AS0200'
}).map(function (d) {
    var _SlotsAvlMap$newDate$;
    var step = Math.ceil(Math.random() * 30);
    var newDate = START_DATE.add(step, 'days').add(10, 'hours');
    var avlSlots = (_SlotsAvlMap$newDate$ = SlotsAvlMap[newDate.format('DD-MM-YYYY')]) !== null && _SlotsAvlMap$newDate$ !== void 0 ? _SlotsAvlMap$newDate$ : 0;
    SlotsAvlMap[newDate.format('DD-MM-YYYY')] = avlSlots + 1;
    return _objectSpread(_objectSpread({}, d), {}, {
        SlotStartTime: newDate.toDate(),
        SlotEndTime: newDate.add(1, 'hours').toDate()
    });
});
export var getColorByDate = function (date) {
    var _SlotsAvlMap$dayjs$fo;
    var percentage = ((_SlotsAvlMap$dayjs$fo = SlotsAvlMap[dayjs(date).format('DD-MM-YYYY')]) !== null && _SlotsAvlMap$dayjs$fo !== void 0 ? _SlotsAvlMap$dayjs$fo : 0) * 10;
    var color = percentage === 0 ? undefined : percentage <= 25 ? info[300] : percentage <= 50 ? success[300] : percentage <= 75 ? warning[300] : error[300];
    return color;
};
